import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledKpisContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  gap: theme.spacing(2),
  [theme.breakpoints.down('xmd')]: {
    flexWrap: 'wrap',
  },
}));
